import { render, staticRenderFns } from "./Boxes.vue?vue&type=template&id=c1e6f522&scoped=true&"
import script from "./Boxes.vue?vue&type=script&lang=js&"
export * from "./Boxes.vue?vue&type=script&lang=js&"
import style0 from "./Boxes.vue?vue&type=style&index=0&id=c1e6f522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e6f522",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1e6f522')) {
      api.createRecord('c1e6f522', component.options)
    } else {
      api.reload('c1e6f522', component.options)
    }
    module.hot.accept("./Boxes.vue?vue&type=template&id=c1e6f522&scoped=true&", function () {
      api.rerender('c1e6f522', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Boxes.vue"
export default component.exports